import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE, getFormattedNumberWithCurrency } from '@skytech/utils'

import { useObject } from './object'
import useSetup from './setup'

export const useFormattedNumberWithCurrency = () => {
  const setup = useSetup()
  const object = useObject()

  const formatNumber = ({
    amount,
    currency,
    locale,
    precision,
    showCurrency = true,
  }: {
    amount: number
    currency?: Intl.NumberFormatOptions['currency']
    locale?: Locale
    precision?: number
    showCurrency?: boolean
  }) =>
    getFormattedNumberWithCurrency({
      amount,
      precision,
      locale: locale || object?.locale || setup?.locale || DEFAULT_LOCALE,
      currency: showCurrency ? currency || setup?.currency : undefined,
    })

  return { formatNumber }
}
